import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-secondary50 text-left" }, "Histórico de validação", -1)
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-2 gap-6"
}
const _hoisted_3 = { class: "flex flex-col gap-5" }

import Modal from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import BiometryEvidencePanel from './BiometryEvidencePanel.vue'
import BiometryHistoryCard from './BiometryHistoryCard.vue'
import DoctorInfoCard from './DoctorInfoCard.vue'
import type { FacialBiometryDoctorItem } from '@/types/facial-biometry.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationHistoryModal',
  props: {
    modelValue: { type: Boolean },
    doctor: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {





function handleClose() {
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "max-width": "max-w-3xl",
    onClose: handleClose
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(FilledButton, {
        "data-testid": "history-close-button",
        text: "Fechar",
        width: "100%",
        height: "48px",
        onClick: handleClose
      })
    ]),
    default: _withCtx(() => [
      (_ctx.doctor)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(BiometryEvidencePanel, {
              "biometry-id": _ctx.doctor.id,
              "testid-prefix": "history",
              "max-height-class": "max-h-[370px]"
            }, null, 8, ["biometry-id"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(DoctorInfoCard, { doctor: _ctx.doctor }, null, 8, ["doctor"]),
              _createVNode(BiometryHistoryCard, { doctor: _ctx.doctor }, null, 8, ["doctor"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})